import { Component, OnInit } from '@angular/core';
import { GridCell, RowCell, VisibilityEnum } from '@urbannex/storethemes';

@Component({
  selector: 'kve-field-summary-popover',
  templateUrl: './field-summary-popover.component.html',
  styleUrls: ['./field-summary-popover.component.scss']
})
export class FieldSummaryPopoverComponent implements OnInit {
  title:string;
  cell:GridCell | RowCell;
  fields:any[]=[];
  visibility:typeof VisibilityEnum = VisibilityEnum;

  constructor() { }

  ngOnInit(): void {
    this.cell.contentElements.forEach(contentEl => {
      let field = {name:"",value:"",visibility:""};
      field.name = contentEl.fieldName?contentEl.fieldName:"No name";
      field.value =  contentEl.text?contentEl.text:"Undefined";
      field.visibility = contentEl.visibility?contentEl.visibility:VisibilityEnum.VISIBLE;
      this.fields.push(field);
    })
    console.log(this.fields);
  }

}
